export const ICON_UNICODE = '\\fea';
export const HEADER_HEIGHT = 109;
export const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API || '';
export const STATUS_OK = 'OK';
export const PLACES_READY_EVENT = 'google.places.api.ready';

/* IMAGE_CONFIG_VALUE is a value added from BE side to add custom image configs,
 * this is located at IWG.Regus/IWG.Regus.Web/App_Config/Include/zzz/Settings.config
 */
export const IMAGE_CONFIG_VALUE = '[imageConfig]';

// TODO: Change solution name to ID's once client define what's going to be send as value
export const SOLUTIONS = {
  COWORKING: '/coworking',
  COWORKING_ID: 'd864dab0-3ff6-4d93-979c-abb50901c23b',
  MEETING_ROOM: '/meeting-rooms',
  MEETING_ROOM_ID: '1fce61ed-57fe-46ad-ac3a-039568e6293d',
  MEMBERSHIP: '/membership',
  MEMBERSHIP_ID: '55cc7246-9d6b-47e5-bce5-e246c20f1a17',
  OFFICE_SPACE: '/office-space',
  OFFICE_SPACE_ID: 'bc212fcb-2c03-486a-abca-1566eb31d586',
  OTHER: 'Other',
  OTHER_ID: '028fdcc4-1a27-4862-847c-abbf9fcb1e4f',
  VIRTUAL_OFFICE: '/virtual-offices',
  VIRTUAL_OFFICE_ID: '4c8aa9b8-bcd7-4b02-bea6-8fde7bda4f02',
};

export const SOLUTION_GROUPS = {
  MEETING_ROOM: 1,
  OTHER: 3,
  VIRTUAL_OFFICE: 2,
};

export const SOLUTIONS_TEMPLATE_IDS = {
  GEO_LOCATION: ['fe19a179', '699ae6f7'],
  LOCATION: '00bb8c06',
};

// Url constants
export const DYNAMIC_PAGE = 'dynamic';
export const SEARCH_PARAMETER = 'search';
export const WORSKSPACE_PARAMETER = 'ws';
export const RESEARCH_PARAMETER = 'rs';
export const BRAND_PARAM = 'brands';
export const MIN_PARAM = 'min';
export const MAX_PARAM = 'max';
export const SORT_BY_QUERY_PARAM = 'sort';
export const SORT_BY_LOW_TO_HIGH = 'asc';
export const SORT_BY_HIGH_TO_LOW = 'desc';
export const SORT_BY_NEAREST = 'near';
export const SORT_BY_FURTHEST = 'far';
export const GLOBAL_SEARCH_PARAM = 'gs';

// Client source images for defaults and fallbacks.
export const LOCATION_IMG = {
  FIRST: {
    DEFAULT: `https://assets.iwgplc.com/image/upload/${IMAGE_CONFIG_VALUE}/v1580898677/Web/Regus/Locations/Regus/5.jpg`,
    FALLBACK: '/-/media/Regus/Settings/Fallbacks/locations_5.ashx',
    DICTIONARY_KEY: 'MainImage',
  },
  SECOND: {
    DEFAULT: `https://assets.iwgplc.com/image/upload/${IMAGE_CONFIG_VALUE}/v1580898677/Web/Regus/Locations/Regus/4.jpg`,
    FALLBACK: '/-/media/Regus/Settings/Fallbacks/locations_4.ashx',
    DICTIONARY_KEY: 'BottomLeft',
  },
  THIRD: {
    DEFAULT: `https://assets.iwgplc.com/image/upload/${IMAGE_CONFIG_VALUE}/v1580898677/Web/Regus/Locations/Regus/2.jpg`,
    FALLBACK: '/-/media/Regus/Settings/Fallbacks/locations_2.ashx',
    DICTIONARY_KEY: 'BottomRight',
  },
};

export const API = {
  BOOK_A_TOUR: '/api/v1/form/bookatour',
  ENQUIRY: '/api/v1/form/enquiry',
  PHONE_VALIDATION: '/api/v1/form/validatecountryphonenumber?',
  WEBCHAT: '/api/webchat/',
  GEO_RESULTS: '/api/v1/geo-results',
  SOLUTION_BUILDER: '/api/v1/solutionbuilder/',
  CLIENT_EVENT_TRACKER: '/clienteventtracker.ashx',
};

export const NAV_MAX_HEIGHT = 120;

export const NAV_MAX_HEIGHT_SMALL_VIEWPORT = 72;

export const CLOUDINARY_BASE_VALUES = {
  crop: 'fill',
  fetchFormat: 'auto',
  quality: 'auto',
};

export const CLOUDINARY_TEST_IMG_EXIST_TRANSFORMATIONS =
  'w_10,c_fill,q_auto,f_auto';

export const SOLUTION_IDS = {
  3000: SOLUTIONS.MEETING_ROOM,
  4000: SOLUTIONS.COWORKING,
  5000: SOLUTIONS.MEMBERSHIP,
  1000: SOLUTIONS.OFFICE_SPACE,
  10000: SOLUTIONS.VIRTUAL_OFFICE,
};

// TODO: Fill all component names used with getComponent() and add them on corresponding locations as constants instead of hardcoded values.
export const COMPONENT_NAMES = {
  enquiryModal: 'EnquiryModal',
  geosolutionHeader: 'GeosolutionHeader',
  locationHeader: 'LocationHeader',
  navBar: 'NavBar',
  solutionBuilderNav: 'SolutionBuilderNav',
  solutionBuilderResults: 'SolutionBuilderResults',
  solutionHero: 'SolutionHero',
  cta: 'CTA',
};

export const NAV = 'nav';

export const DEFAULT_COUNTRY = 'US';

export const TEMPLATES_IDS = {
  locationTemplateId: '00bb8c06-4591-4797-9e7e-74aaf00848a7',
};

// Transportation types offered by google
export const TRANSPORTATION = {
  TYPES: {
    BUS: 'bus_station',
    TRANSIT: 'transit_station',
    POINT: 'point_of_interest',
  },
  DICTIONARY_KEYS: {
    light_rail_station: 'LightRailStation',
    subway_station: 'SubwayStation',
    train_station: 'TrainStation',
    transit_station: 'TransitStation',
  },
};

// The following ids are created for analytics tracking.
export const NAVBAR_IDS = {
  CLOSE_ACTIVE: 'nav-close-active',
  CLOSE: 'nav-close',
  CONTACT_ACTIVE: 'nav-contact-active',
  CONTACT: 'nav-contact',
  GET_IN_TOUCH: 'nav-get-in-touch',
  HOME: 'nav-home',
  LOGIN: 'nav-login',
  PHONE_NUMBER: 'nav-phone-number',
  SEARCH_ACTIVE: 'nav-search-active',
  SEARCH: 'nav-search',
  SOLUTION_BUILDER: 'solution-builder-nav',
  WAYS_TO_WORK_ACTIVE: 'nav-ways-to-work-active',
  WAYS_TO_WORK: 'nav-ways-to-work',
};

// Form consts
export const FIRST_NAME_INPUT = 'firstName';
export const EMAIL_INPUT = 'email';
export const REG_ONLY_NUMBERS = '^[0-9]*$';
export const MINIMUM_CHARACTERS_TO_SEARCH = 3;

//Search radius mi
export const ADDITIONAL_SEARCH_RADIUS_MILES = 20;
//Minimum search radius
export const MINIMUM_SEARCH_RADIUS = 0.5;

//RTL languages list we keep on FE in this constant
export const RTL_LANGUAGES = ['ar', 'he'];
